import React from 'react'

export const mississippiSetupVars = {
  siteId: 'mississippi',
  pathPrefix: '/ms',
  menuHeader: "Discover Mississippi's Solution for:",
  appUrl: 'https://ms.headed2.com',
  logoImg: '/images/assets/mississippi/horizontal/dark.svg',
  headerTitle: `The Mississippi CareerExplorer is a system designed for Mississippi`
}
